/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Server_OfflineInputs */



/**
* | output |
* | --- |
* | "The Server option needs an internet connection." |
*
* @param {Embed_Captions_Server_OfflineInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_server_offline = /** @type {((inputs?: Embed_Captions_Server_OfflineInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Server_OfflineInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'option Serveur nécessite une connexion Internet.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Serveroption erfordert eine Internetverbindung.")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'opzione Server richiede una connessione a Internet.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Для выбора варианта \"Сервер\" требуется подключение к интернету.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La opción Servidor requiere conexión a internet.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("服务器选项需要连接互联网。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サーバーオプションを使用するには、インターネット接続が必要です。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सर्वर विकल्प के लिए इंटरनेट कनेक्शन आवश्यक है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A opção Servidor requer uma conexão com a internet.")
	return /** @type {LocalizedString} */ ("The Server option needs an internet connection.")
});